import { OptionDto } from "@/dtos";
import { IncidenceDateOption } from "@/helpers/types";

const dateOptions = [
    { value: IncidenceDateOption.DATE_CREATION, label: 'Fecha de creación' },
    { value: IncidenceDateOption.DATE_PLANIFICATION, label: 'Fecha de planificación' },
    { value: IncidenceDateOption.DATE_EXECUTION, label: 'Fecha de ejecución' },
] as OptionDto[];

export const getIncidenceDateOptions = (): OptionDto[] => {
    return dateOptions;
}

export const getIncidenceDateOption = (value?: number): OptionDto => {
    return dateOptions.find((x) => x.value == value) ?? dateOptions[0];
}